import React, { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../utils/axiosConfig';
import { toast } from 'react-toastify';

interface AyarState {
  servisAktif: boolean;
  baseUrl: string;
  instanceName: string;
  apiKeyVarMi: boolean;
  apiKeyMaskeli: string;
  atamaBildirimiAktif: boolean;
  randevuHatirlaticiAktif: boolean;
  teklifOnayAktif: boolean;
  teklifDurumAktif: boolean;
}

const BOS_AYAR: AyarState = {
  servisAktif: false,
  baseUrl: '',
  instanceName: '',
  apiKeyVarMi: false,
  apiKeyMaskeli: '',
  atamaBildirimiAktif: false,
  randevuHatirlaticiAktif: false,
  teklifOnayAktif: false,
  teklifDurumAktif: false,
};

const WhatsAppAyarlari: React.FC = () => {
  const [ayar, setAyar] = useState<AyarState>(BOS_AYAR);
  const [yeniApiKey, setYeniApiKey] = useState('');
  const [keyDirty, setKeyDirty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [durumSonuc, setDurumSonuc] = useState<{ bagli: boolean; mesaj: string } | null>(null);
  const [testTelefon, setTestTelefon] = useState('');
  const [testMesaj, setTestMesaj] = useState('Yapı CRM — test mesajı.');
  const [testGonderiyor, setTestGonderiyor] = useState(false);
  const [testSonuc, setTestSonuc] = useState<{ basarili: boolean; mesaj: string } | null>(null);

  const fetchAyar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/api/WhatsAppAyarlari');
      setAyar({
        servisAktif: !!res.data.servisAktif,
        baseUrl: res.data.baseUrl || '',
        instanceName: res.data.instanceName || '',
        apiKeyVarMi: !!res.data.apiKeyVarMi,
        apiKeyMaskeli: res.data.apiKeyMaskeli || '',
        atamaBildirimiAktif: !!res.data.atamaBildirimiAktif,
        randevuHatirlaticiAktif: !!res.data.randevuHatirlaticiAktif,
        teklifOnayAktif: !!res.data.teklifOnayAktif,
        teklifDurumAktif: !!res.data.teklifDurumAktif,
      });
    } catch {
      toast.error('Ayarlar yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAyar(); }, [fetchAyar]);

  const handleKaydet = async (apiKeyTemizle = false) => {
    setSaving(true);
    setDurumSonuc(null);
    try {
      await axiosInstance.post('/api/WhatsAppAyarlari/update/1', {
        servisAktif: ayar.servisAktif,
        baseUrl: ayar.baseUrl,
        instanceName: ayar.instanceName,
        yeniApiKey: !apiKeyTemizle && keyDirty ? yeniApiKey : null,
        apiKeyTemizle,
        atamaBildirimiAktif: ayar.atamaBildirimiAktif,
        randevuHatirlaticiAktif: ayar.randevuHatirlaticiAktif,
        teklifOnayAktif: ayar.teklifOnayAktif,
        teklifDurumAktif: ayar.teklifDurumAktif,
      });
      toast.success('WhatsApp ayarları kaydedildi.');
      setYeniApiKey('');
      setKeyDirty(false);
      fetchAyar();
    } catch {
      toast.error('Kaydetme sırasında hata oluştu.');
    } finally {
      setSaving(false);
    }
  };

  const handleDurumKontrol = async () => {
    setTesting(true);
    setDurumSonuc(null);
    try {
      const res = await axiosInstance.post('/api/WhatsAppAyarlari/durum');
      const bagli = !!res.data.bagli;
      const durum = res.data.durum || '';
      const hata = res.data.hataMesaji || '';
      setDurumSonuc({
        bagli,
        mesaj: bagli
          ? `Bağlı${durum ? ` (${durum})` : ''}`
          : hata || 'Bağlantı kurulamadı.',
      });
    } catch {
      setDurumSonuc({ bagli: false, mesaj: 'Durum isteği gönderilemedi.' });
    } finally {
      setTesting(false);
    }
  };

  const handleTestGonder = async () => {
    if (!testTelefon.trim()) { toast.error('Telefon numarası girin.'); return; }
    setTestGonderiyor(true);
    setTestSonuc(null);
    try {
      const res = await axiosInstance.post('/api/WhatsAppGonder/test', { telefon: testTelefon.trim(), mesaj: testMesaj });
      const basarili = !!res.data.basarili;
      setTestSonuc({
        basarili,
        mesaj: basarili
          ? 'Test mesajı başarıyla gönderildi.'
          : res.data.servisPasif
            ? 'Servis pasif — önce bağlantı parametrelerini girin ve kaydedin.'
            : res.data.hataMesaji || 'Gönderilemedi.',
      });
    } catch {
      setTestSonuc({ basarili: false, mesaj: 'Test isteği gönderilemedi.' });
    } finally {
      setTestGonderiyor(false);
    }
  };

  const inp: React.CSSProperties = { width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '0.875rem', outline: 'none', boxSizing: 'border-box' };
  const lbl: React.CSSProperties = { display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#374151', marginBottom: 6 };
  const kart: React.CSSProperties = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', padding: 24, maxWidth: 640, marginBottom: 20 };

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
        <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>Yükleniyor...
      </div>
    );
  }

  return (
    <div style={{ padding: '28px 32px', background: '#f4f6fb', minHeight: '100vh', fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      {/* Başlık */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 22 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: '#1a2440', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="fab fa-whatsapp" style={{ color: '#25d366', fontSize: 22 }}></i>
        </div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', gap: 10 }}>
            WhatsApp Ayarları
            {ayar.servisAktif && (
              <span style={{ padding: '2px 10px', background: '#dcfce7', color: '#15803d', border: '1px solid #86efac', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
                Etkin
              </span>
            )}
          </div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>Evolution API v2 bağlantı ve otomatik bildirim ayarları</div>
        </div>
      </div>

      {/* Bağlantı Parametreleri Kartı */}
      <div style={kart}>
        {/* Servis toggle */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid #f1f5f9' }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>WhatsApp servisini etkinleştir</div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>Kapalıyken otomatik mesaj gönderilmez (test hariç).</div>
          </div>
          <span
            onClick={() => setAyar(p => ({ ...p, servisAktif: !p.servisAktif }))}
            style={{ width: 42, height: 24, borderRadius: 12, background: ayar.servisAktif ? '#059669' : '#cbd5e1', position: 'relative', transition: 'background 0.15s ease', flexShrink: 0, cursor: 'pointer', display: 'inline-block' }}
          >
            <span style={{ position: 'absolute', top: 2, left: ayar.servisAktif ? 20 : 2, width: 20, height: 20, borderRadius: '50%', background: '#fff', transition: 'left 0.15s ease', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }} />
          </span>
        </div>

        {/* Evolution API URL + Instance */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <label style={lbl}>Evolution API URL</label>
            <input
              type="text"
              value={ayar.baseUrl}
              onChange={e => setAyar(p => ({ ...p, baseUrl: e.target.value }))}
              style={inp}
              placeholder="https://wa.vizitrocrm.com"
            />
          </div>
          <div>
            <label style={lbl}>Instance Name (Oturum Adı)</label>
            <input
              type="text"
              value={ayar.instanceName}
              onChange={e => setAyar(p => ({ ...p, instanceName: e.target.value }))}
              style={inp}
              placeholder="Yapı CRM"
            />
          </div>
        </div>

        {/* API Key */}
        <div style={{ marginTop: 16 }}>
          <label style={lbl}>
            API Key
            {ayar.apiKeyVarMi && (
              <span style={{ marginLeft: 8, fontWeight: 500, color: '#059669' }}>
                <i className="fas fa-check-circle" style={{ marginRight: 4 }} />kayıtlı
              </span>
            )}
          </label>
          <input
            type="password"
            autoComplete="new-password"
            value={yeniApiKey}
            onChange={e => { setYeniApiKey(e.target.value); setKeyDirty(true); }}
            style={inp}
            placeholder={ayar.apiKeyVarMi ? ayar.apiKeyMaskeli : 'API anahtarını girin...'}
          />
          {ayar.apiKeyVarMi && (
            <button
              onClick={() => handleKaydet(true)}
              disabled={saving}
              style={{ marginTop: 6, background: 'none', border: 'none', padding: 0, color: '#dc2626', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}
            >
              Anahtarı sil
            </button>
          )}
        </div>

        {/* Durum sonucu */}
        {durumSonuc && (
          <div style={{
            marginTop: 14, padding: '10px 14px', borderRadius: 10, fontSize: 12.5, fontWeight: 500,
            background: durumSonuc.bagli ? '#f0fdf4' : '#fef2f2',
            border: `1px solid ${durumSonuc.bagli ? '#86efac' : '#fecaca'}`,
            color: durumSonuc.bagli ? '#15803d' : '#b91c1c',
          }}>
            <i className={`fas fa-${durumSonuc.bagli ? 'circle-check' : 'circle-exclamation'}`} style={{ marginRight: 6 }} />
            {durumSonuc.mesaj}
          </div>
        )}

        {/* Butonlar */}
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button
            onClick={handleDurumKontrol}
            disabled={testing || saving}
            style={{ padding: '10px 18px', border: '1px solid #d1d5db', borderRadius: 9, background: '#fff', color: '#374151', fontSize: 13.5, fontWeight: 600, cursor: testing ? 'not-allowed' : 'pointer' }}
          >
            <i className={testing ? 'fas fa-spinner fa-spin' : 'fas fa-plug'} style={{ marginRight: 6 }}></i>
            {testing ? 'Kontrol ediliyor...' : 'Bağlantı Durumunu Kontrol Et'}
          </button>
          <button
            onClick={() => handleKaydet(false)}
            disabled={saving}
            style={{ padding: '10px 22px', border: 'none', borderRadius: 9, background: saving ? '#94a3b8' : '#1a2440', color: '#fff', fontSize: 13.5, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            <i className="fas fa-save" style={{ marginRight: 6 }}></i>{saving ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </div>
      </div>

      {/* Otomatik Bildirimler Kartı */}
      <div style={kart}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>Otomatik WhatsApp Bildirimleri</div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20 }}>İlgili olay gerçekleştiğinde seçili kişilere otomatik mesaj gönderilir.</div>

        {[
          { key: 'atamaBildirimiAktif' as keyof AyarState, label: 'Yeni Müşteri / Fırsat Atama Bildirimi', aciklama: 'Sorumlu personele yeni müşteri/fırsat atandığında anlık bildirim.' },
          { key: 'randevuHatirlaticiAktif' as keyof AyarState, label: 'Randevu & Görüşme Hatırlatıcı', aciklama: 'Müşteriye ve ilgili temsilciye yaklaşan randevu/toplantı bildirimi.' },
          { key: 'teklifOnayAktif' as keyof AyarState, label: 'Teklif ve İskonto Onay Bildirimleri', aciklama: 'Özel iskonto veya teklif onayına sunulduğunda yöneticilere bildirim.' },
          { key: 'teklifDurumAktif' as keyof AyarState, label: 'Teklif Durum Güncellemesi', aciklama: 'Teklif oluşturulduğunda veya onaylandığında müşteriye otomatik bilgi mesajı.' },
        ].map(item => (
          <div
            key={item.key}
            style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '12px 0', borderBottom: '1px solid #f1f5f9' }}
          >
            <input
              type="checkbox"
              id={item.key}
              checked={!!ayar[item.key]}
              onChange={e => setAyar(p => ({ ...p, [item.key]: e.target.checked }))}
              style={{ marginTop: 3, width: 16, height: 16, accentColor: '#e67d21', cursor: 'pointer', flexShrink: 0 }}
            />
            <label htmlFor={item.key} style={{ cursor: 'pointer' }}>
              <div style={{ fontSize: 13.5, fontWeight: 600, color: '#1e293b' }}>{item.label}</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{item.aciklama}</div>
            </label>
          </div>
        ))}

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => handleKaydet(false)}
            disabled={saving}
            style={{ padding: '10px 22px', border: 'none', borderRadius: 9, background: saving ? '#94a3b8' : '#1a2440', color: '#fff', fontSize: 13.5, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            <i className="fas fa-save" style={{ marginRight: 6 }}></i>{saving ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </div>
      </div>

      {/* Test Mesajı Kartı */}
      <div style={kart}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>Test Mesajı Gönder</div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20 }}>Ayarlar henüz aktif edilmemiş olsa bile deneme mesajı gönderebilirsiniz.</div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <label style={lbl}>Cep Telefonu</label>
            <input
              type="tel"
              value={testTelefon}
              onChange={e => setTestTelefon(e.target.value)}
              style={inp}
              placeholder="05XX..."
            />
          </div>
          <div>
            <label style={lbl}>Test Mesajı Metni</label>
            <input
              type="text"
              value={testMesaj}
              onChange={e => setTestMesaj(e.target.value)}
              style={inp}
              placeholder="Test mesajı..."
            />
          </div>
        </div>

        {testSonuc && (
          <div style={{
            marginTop: 14, padding: '10px 14px', borderRadius: 10, fontSize: 12.5, fontWeight: 500,
            background: testSonuc.basarili ? '#f0fdf4' : '#fef2f2',
            border: `1px solid ${testSonuc.basarili ? '#86efac' : '#fecaca'}`,
            color: testSonuc.basarili ? '#15803d' : '#b91c1c',
          }}>
            <i className={`fas fa-${testSonuc.basarili ? 'circle-check' : 'circle-exclamation'}`} style={{ marginRight: 6 }} />
            {testSonuc.mesaj}
          </div>
        )}

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={handleTestGonder}
            disabled={testGonderiyor}
            style={{ padding: '10px 20px', border: 'none', borderRadius: 9, background: testGonderiyor ? '#94a3b8' : '#25d366', color: '#fff', fontSize: 13.5, fontWeight: 700, cursor: testGonderiyor ? 'not-allowed' : 'pointer' }}
          >
            <i className={testGonderiyor ? 'fas fa-spinner fa-spin' : 'fab fa-whatsapp'} style={{ marginRight: 6 }}></i>
            {testGonderiyor ? 'Gönderiliyor...' : 'Test Gönder'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppAyarlari;
